module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "heightOverride": 400,
      "closeButton": ""
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "dropped_attributes_details"
  }, [(_vm.loading) ? [_c('loader-dots', {
    staticClass: "dropped_attributes_details__loading"
  })] : _vm._l((_vm.droppedAttributes), function(data) {
    return _c('div', {
      key: data.quarter
    }, [_c('div', {
      staticClass: "dropped_attributes_details__quarter-panel"
    }, [_vm._v("\n          " + _vm._s(_vm.getQuarterString(data.quarter)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "dropped_attributes_details__attribute-panel"
    }, _vm._l((data.attributes), function(attribute, i) {
      return _c('div', {
        key: i
      }, [_c('oval-label', {
        staticClass: "dropped_attributes_details__attribute"
      }, [_vm._v("\n              " + _vm._s(attribute) + "\n            ")])], 1)
    }), 0)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f2426be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/modals/DroppedAttributesModal.vue
// module id = 1962
// module chunks = 0